module.exports = global["ReactDOM"] = require("-!./index.js");


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/react-dom/index.js-exposed
// module id = 47
// module chunks = 4 5 6 7 8 9 10 11 12 13 14